import Form from '../form/form'

export default (function() {
  'use strict';

  const helocElement = document.querySelector('.heloc-form')
  let helocForm;

  function init() {
    if (!helocElement) {
      return;
    }

    helocForm = new Form(helocElement)

    helocForm.successHandler = function(data) {
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({ event: 'GAVirtualPageview', virtualPageviewUrl: '/heloc/thank-you/' })
      }
    }
  }

  return {
    init,
  }
})();
